import { Alert, Button, Form, Input, Modal, Row } from "antd";
import { buttonStyle, fullWidthStyle, titleStyle } from "../../constants/style";
import { SubmitStatus } from "../../api/work-order-api";
import ApiContext from "../../api/context";
import { useContext, useEffect, useState } from "react";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import { Template } from "../../api/models";

type TemplateRenameProps = {
  template?: Template,
  onClose: () => void,
  onSave: (template: Template) => void
};

export default function (p: TemplateRenameProps) {
  const [submitStatus, setSubmitStatus] = useState<SubmitStatus>(SubmitStatus.Idle);
  const [error, setError] = useState<string>();
  const [newName, setNewName] = useState<string>();
  const { api } = useContext(ApiContext);
  const isSubmitting = submitStatus === SubmitStatus.Submitting;
  const isNameValid = newName?.trim().length ?? 0 > 0;
  const canSubmit = !isSubmitting && isNameValid;

  useEffect(() => {
    setSubmitStatus(SubmitStatus.Idle);
    setError(undefined);
    setNewName(undefined);
  }, [p.template?.templateID]);

  return (
    <>
      <Title style={titleStyle} level={4}>Rename Template</Title>
      <Form
        layout="vertical"
        colon={false}>
        <Form.Item label="Template Name">
          <Input
            placeholder={p.template?.name}
            value={newName}
            onChange={e => setNewName(e.target.value)}
          />
        </Form.Item>
        <Row style={fullWidthStyle} justify="end" align="middle">
          <Button
            type="default"
            style={buttonStyle}
            onClick={p.onClose}>
            Close
          </Button>
          <Button
            type="primary"
            style={buttonStyle}
            disabled={!canSubmit}
            loading={isSubmitting}
            onClick={() => {
              setSubmitStatus(SubmitStatus.Submitting);
              api?.putTemplate({
                ...p.template!,
                name: newName ?? p.template!.name
              }).then(response => {
                if (!response.good() || !response.body) {
                  throw "Bad response received.";
                }

                p.onSave(response.body);
              }).catch(err => {
                setError("Failed to rename the template.");
                setSubmitStatus(SubmitStatus.Idle);
              });
            }}>
            Rename
          </Button>
        </Row>
        {
          !error ? undefined :
            <>
              <Paragraph></Paragraph>
              <Alert style={fullWidthStyle} type="error" title={error} />
            </>
        }
      </Form>
    </>);
}

